var map = {
  "./en.json": [
    "cm",
    [
      67
    ]
  ],
  "./_reports/ja.untranslated.json": [
    "q6",
    [
      "cp"
    ]
  ],
  "./zh.json": [
    "SU",
    [
      "cu"
    ]
  ],
  "./_reports/_sync-report.json": [
    "JQK",
    [
      "nt"
    ]
  ],
  "./_reports/zh.untranslated.json": [
    "Aq",
    [
      6
    ]
  ],
  "./ja.json": [
    "LN",
    [
      "p6"
    ]
  ],
  "./tw.json": [
    "bs",
    [
      1
    ]
  ],
  "./_reports/ru.untranslated.json": [
    "v3",
    [
      "l5"
    ]
  ],
  "./_reports/vi.untranslated.json": [
    "q1t",
    [
      859
    ]
  ],
  "./fr.json": [
    "LA",
    [
      "1r"
    ]
  ],
  "./ko.json": [
    "oe0",
    [
      "2v"
    ]
  ],
  "./ru.json": [
    "OA",
    [
      "gu"
    ]
  ],
  "./_reports/fr.untranslated.json": [
    "Mj",
    [
      "2u"
    ]
  ],
  "./vi.json": [
    "Bg",
    [
      "j"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "fh";
module.exports = __rspack_async_context;
